window.HowlerConfig = {
  algolia: {
    applicationId: window.APP_CONFIG?.algolia?.applicationId,
    apiKey: window.APP_CONFIG?.algolia?.apiKey,
  },
  google: {
    apiKey: window.APP_CONFIG?.google?.apiKey,
  },
  breakpoints: {
    small: 0,
    medium: 720,
    large: 1024,
    xlarge: 1280,
    xxlarge: 1440,
  },
  environment: window.APP_CONFIG?.environment,
};
